/* MSALHelperMethods
* 2026-06-18 - Refactored for TWS-LowBandwidth from TWS-Combined
*/

import { PublicClientApplication } from '@azure/msal-browser';
import * as config from '../../config/envConfig';

const SomethingWentWrong = "Something went wrong, Please login again.";

/**
 * Gets a MSAL instance with predefined configuration
 * @returns {PublicClientApplication} The MSAL instance
 */
const getMSALInstance = () => {
    const msalConfig = {
        auth: {
            clientId: config.LOGIN_CLIENT_ID,
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: true
        }
    };
    const MSALInstance = new PublicClientApplication(msalConfig);

    return MSALInstance;
}

/**
 * Login a user with popup and get the access token
 * @param {string} userEmail 
 * @param {function(string, Error)} onError 
 * @param {function(AuthenticationResult)} onLoginSuccess 
 * @returns AuthenticationResult if login is successful, undefined otherwise
 */
export const loginWithPopup = async (userEmail, onError, onLoginSuccess) => {
    try {
        const MSALInstance = getMSALInstance();
        let apiScope = config.LOGIN_SCOPE;

        const loginConfig = {
            scopes: [apiScope, 'openid'],
            loginHint: userEmail,
        };

        let result = await MSALInstance.loginPopup(loginConfig);

        let account = result.account;
        MSALInstance.setActiveAccount(account);

        return await refreshAccessTokenSilently(onError, onLoginSuccess);
    } catch (err) {
        console.log('Login failure.', err)
        onError(SomethingWentWrong, err);
    }
}

/**
 * Login a user with redirect and get the access token
 * @param {string} userEmail 
 * @param {function(string, Error)} onError 
 */
export const loginWithRedirect = (userEmail, onError) => {
    try {
        const MSALInstance = getMSALInstance();
        let apiScope = config.LOGIN_SCOPE;

        const loginConfig = {
            scopes: [apiScope, 'openid'],
            loginHint: userEmail,
        };

        MSALInstance.loginRedirect(loginConfig);
    } catch (err) {
        console.log('Login failure.', err)
        onError(SomethingWentWrong, err);
    }
}

/**
 * This is a helper method to refresh access token silently using MSAL library
 * @param {function(string, Error)} onError
 * @param {function(AuthenticationResult)} onSuccess
 * @returns AuthenticationResult if token is refreshed successfully, undefined otherwise
 */
export const refreshAccessTokenSilently = async (onError, onSuccess) => {
    try {
        const MSALInstance = getMSALInstance();

        var activeAccount = MSALInstance.getActiveAccount();
        let apiScope = config.LOGIN_SCOPE;

        var accessTokenRequest = {
            account: activeAccount,
            scopes: [apiScope, 'openid'],
        };

        const accessTokenResponse = await MSALInstance.acquireTokenSilent(accessTokenRequest);

        onSuccess(accessTokenResponse);

        return accessTokenResponse;
    } catch (err) {
        console.log('Token refresh failure.', err);
        onError(SomethingWentWrong, err);
    }

    return undefined;
}

/**
 * Get the currently active MSAL Account
 * @returns The active account, or null if there is no active account
 */
export const getActiveAccount = () => {
    return getMSALInstance().getActiveAccount();
}

/**
 * Get whether the login method will be with redirect or with popup.
 */
export const isUsingLoginRedirect = () => config.USE_REDIRECT === "true" || config.USE_REDIRECT === true;

/**
 * Check if the redirect login has just occured
 * @param {function(Error)} updateError
 * @param {function(AuthenticationSuccess)} onLoginSuccess
 */
export const checkRedirectLogin = async (updateError, onLoginSuccess) => {
    const MSALInstance = getMSALInstance();

    MSALInstance.handleRedirectPromise().then((authResponse) => {
        onHandleRedirectPromiseComplete(authResponse, updateError, onLoginSuccess);
    });
}

/**
 * 
 * @param {AuthenticationResult} authResponse 
 * @param {function(Error)} updateError
 * @param {function(AuthenticationSuccess)} onLoginSuccess
 * @returns 
 */
const onHandleRedirectPromiseComplete = (authResponse, updateError, onLoginSuccess) => {
    if (authResponse === undefined || authResponse === null) return;

    const MSALInstance = getMSALInstance();

    let account = authResponse.account;
    MSALInstance.setActiveAccount(account);

    //await refreshAccessTokenSilently(updateError, onLoginSuccess);

    onLoginSuccess(authResponse); // enable if wishing to remove above immediate refresh request
}